(function () {
  'use strict';
  /* build: 20260628-finder-quiz-v4 */

  var STORAGE_KEY = 'tcbEquipmentFinderState';
  var TOTAL_STEPS = 8;
  var PRIMARY_GRID_SIZE = 6;
  var SECONDARY_GRID_SIZE = 6;
  var RECOMMENDATION_TOTAL = PRIMARY_GRID_SIZE + SECONDARY_GRID_SIZE;

  var EQUIPMENT_PRODUCT_IDS = {
    floor_scrubber: ['floor-scrubbers', 'walk-behind-floor-scrubbers', 'ride-on-floor-scrubbers'],
    sweeper: ['sweepers', 'floor-sweepers'],
    carpet_extractor: ['carpet-extractors'],
    commercial_vacuum: ['commercial-vacuums'],
    wet_dry: ['wet-dry-vacuums', 'commercial-vacuums'],
    floor_buffer: ['floor-buffers'],
    burnisher: ['burnishers'],
    parts: ['parts'],
    chemicals: ['chemicals']
  };

  var QUESTIONS = [
    {
      id: 'task',
      title: 'What are you trying to clean?',
      type: 'grid',
      multi: true,
      selectionHint: 'Select all that apply',
      options: [
        { label: 'Hard floors', value: 'hard_floors', icon: 'floor' },
        { label: 'Carpet', value: 'carpet', icon: 'carpet' },
        { label: 'Concrete warehouse floors', value: 'warehouse_concrete', icon: 'warehouse' },
        { label: 'Restrooms', value: 'restrooms', icon: 'restroom' },
        { label: 'Kitchen or greasy floors', value: 'greasy_floors', icon: 'kitchen' },
        { label: 'Gym floors', value: 'gym_floors', icon: 'gym' },
        { label: 'Office spaces', value: 'office_spaces', icon: 'office' },
        { label: 'Entire facility', value: 'entire_facility', icon: 'facility' },
        { label: 'I need replacement parts', value: 'parts', icon: 'parts' },
        { label: 'I need chemicals and supplies', value: 'chemicals', icon: 'chemicals' }
      ]
    },
    {
      id: 'equipment',
      title: 'What type of equipment are you looking for?',
      type: 'grid',
      selectionHint: 'Select one',
      options: [
        { label: 'Floor scrubber', value: 'floor_scrubber', icon: 'scrubber' },
        { label: 'Sweeper', value: 'sweeper', icon: 'sweeper' },
        { label: 'Carpet extractor', value: 'carpet_extractor', icon: 'extractor' },
        { label: 'Commercial vacuum', value: 'commercial_vacuum', icon: 'vacuum' },
        { label: 'Floor buffer', value: 'floor_buffer', icon: 'buffer' },
        { label: 'Burnisher', value: 'burnisher', icon: 'burnisher' },
        { label: 'Wet/dry vacuum', value: 'wet_dry', icon: 'wetdry' },
        { label: 'Parts', value: 'parts', icon: 'parts' },
        { label: 'Chemicals', value: 'chemicals', icon: 'chemicals' },
        { label: 'Complete package', value: 'complete_package', icon: 'package' },
        { label: 'Not sure', value: 'not_sure', icon: 'help' }
      ]
    },
    {
      id: 'facility',
      title: 'What type of facility do you clean?',
      type: 'grid',
      selectionHint: 'Select one',
      options: [
        { label: 'Office building', value: 'office', icon: 'office' },
        { label: 'School', value: 'school', icon: 'school' },
        { label: 'Church', value: 'church', icon: 'church' },
        { label: 'Gym', value: 'gym', icon: 'gym' },
        { label: 'Restaurant', value: 'restaurant', icon: 'kitchen' },
        { label: 'Warehouse', value: 'warehouse', icon: 'warehouse' },
        { label: 'Hotel', value: 'hotel', icon: 'hotel' },
        { label: 'Apartment / property manager', value: 'property_manager', icon: 'property' },
        { label: 'Healthcare facility', value: 'healthcare', icon: 'healthcare' },
        { label: 'Janitorial contractor', value: 'contractor', icon: 'contractor' },
        { label: 'Cleaning business startup', value: 'startup', icon: 'startup' },
        { label: 'Other', value: 'other', icon: 'help' }
      ]
    },
    {
      id: 'size',
      title: 'How large is the area?',
      type: 'list',
      selectionHint: 'Select one',
      options: [
        { label: 'Under 5,000 sq ft', value: 'under_5000' },
        { label: '5,000–25,000 sq ft', value: '5000_25000' },
        { label: '25,000–75,000 sq ft', value: '25000_75000' },
        { label: '75,000+ sq ft', value: '75000_plus' },
        { label: 'Multiple locations', value: 'multiple' },
        { label: 'Not sure', value: 'not_sure' }
      ]
    },
    {
      id: 'condition',
      title: 'Do you prefer new, used, or refurbished equipment?',
      type: 'list',
      selectionHint: 'Select one',
      note: {
        icon: 'info',
        text: 'Used and refurbished inventory changes frequently. Request a quote and our team will confirm current availability.'
      },
      options: [
        { label: 'New equipment', value: 'new' },
        { label: 'Used or refurbished equipment', value: 'used' },
        { label: 'Either is fine', value: 'either' },
        { label: 'I need help deciding', value: 'help' }
      ]
    },
    {
      id: 'budget',
      title: 'What is your budget range?',
      type: 'list',
      selectionHint: 'Select one',
      note: {
        icon: 'dollar',
        text: 'Financing may be available on qualifying commercial equipment purchases.'
      },
      options: [
        { label: 'Under $1,000', value: 'under_1000' },
        { label: '$1,000–$3,000', value: '1000_3000' },
        { label: '$3,000–$7,500', value: '3000_7500' },
        { label: '$7,500–$15,000', value: '7500_15000' },
        { label: '$15,000+', value: '15000_plus' },
        { label: 'Not sure', value: 'not_sure' }
      ]
    },
    {
      id: 'intent',
      title: 'What do you want next?',
      type: 'list',
      selectionHint: 'Select one',
      options: [
        { label: 'Show me recommended equipment', value: 'show_equipment', icon: 'equipment' },
        { label: 'Build me a package', value: 'complete_package', icon: 'package' },
        { label: 'Have an expert contact me', value: 'expert', icon: 'expert' },
        { label: 'Show me photos of each equipment type', value: 'show_photos', icon: 'photos' }
      ]
    }
  ];

  var SUMMARY_FIELDS = [
    { id: 'task', label: 'Cleaning Task', icon: 'floor' },
    { id: 'equipment', label: 'Equipment Type', icon: 'scrubber' },
    { id: 'facility', label: 'Facility Type', icon: 'school' },
    { id: 'size', label: 'Area Size', icon: 'facility' },
    { id: 'condition', label: 'Condition', icon: 'help' },
    { id: 'budget', label: 'Budget', icon: 'package' },
    { id: 'intent', label: 'Next Step', icon: 'equipment' }
  ];

  var ADD_ONS = [
    { name: 'Pads & Brushes', url: '/collections/shop-all-parts', icon: 'floor' },
    { name: 'Squeegee Blades', url: '/collections/shop-all-parts', icon: 'parts' },
    { name: 'Neutral Floor Cleaner', url: '/collections/cleaning-chemicals', icon: 'chemicals' },
    { name: 'Wet Floor Signs', url: '/collections/shop-all-supplies', icon: 'facility' },
    { name: 'Batteries & Charger', url: '/collections/shop-all-parts', icon: 'parts' },
    { name: 'Maintenance Parts', url: '/collections/shop-all-parts', icon: 'parts' },
    { name: 'Hoses & Wands', url: '/collections/shop-all-parts', icon: 'extractor' },
    { name: 'Filters & Bags', url: '/collections/shop-all-parts', icon: 'vacuum' },
    { name: 'Microfiber Towels', url: '/collections/shop-all-supplies', icon: 'chemicals' },
    { name: 'Restroom Supplies', url: '/collections/cleaning-chemicals', icon: 'restroom' }
  ];

  var GALLERY = [
    { name: 'Floor Scrubbers', url: '/collections/floor-scrubbers', key: 'floor-scrubbers' },
    { name: 'Sweepers', url: '/collections/floor-sweepers', key: 'sweepers' },
    { name: 'Carpet Extractors', url: '/collections/carpet-extractors', key: 'carpet-extractors' },
    { name: 'Commercial Vacuums', url: '/collections/commercial-vacuums', key: 'commercial-vacuums' },
    { name: 'Floor Buffers', url: '/collections/buffers-burnishers', key: 'floor-buffers' },
    { name: 'Burnishers', url: '/collections/buffers-burnishers', key: 'burnishers' },
    { name: 'Industrial Equipment', url: '/collections/shop-all-equipment', key: 'industrial-cleaning-equipment' },
    { name: 'Parts', url: '/collections/shop-all-parts', key: 'parts' },
    { name: 'Chemicals', url: '/collections/cleaning-chemicals', key: 'chemicals' },
    { name: 'Pressure Washers', url: '/collections/pressure-washers', key: 'pressure-washers' },
    { name: 'Supplies', url: '/collections/shop-all-supplies', key: 'supplies' },
    { name: 'Restoration Equipment', url: '/collections/restoration-equipment', key: 'restoration-equipment' }
  ];

  var PRODUCT_FALLBACKS = [
    { id: 'floor-scrubbers', name: 'Floor Scrubbers', url: '/collections/floor-scrubbers', imageLabel: 'Floor Scrubber', description: 'Compare commercial scrubbers for daily hard-floor cleaning and wet recovery.' },
    { id: 'commercial-vacuums', name: 'Commercial Vacuums', url: '/collections/commercial-vacuums', imageLabel: 'Commercial Vacuum', description: 'Best for daily janitorial routes, carpet pickup, and routine facility cleaning.' },
    { id: 'chemicals', name: 'Chemicals & Supplies', url: '/collections/cleaning-chemicals', imageLabel: 'Chemicals', description: 'Shop floor cleaners, degreasers, restroom cleaners, and odor control supplies.' }
  ];

  var PACKAGE_FALLBACKS = [
    { id: 'packages-hub', name: 'Custom Equipment Packages', url: '/pages/packages', imageLabel: 'Custom Package', description: 'Start here for a full custom package with machines, supplies, chemicals, and expert support.' },
    { id: 'floor-scrubber-packages', name: 'Floor Scrubber Packages', url: '/pages/floor-scrubber-packages', imageLabel: 'Scrubber Package', description: 'Packages built around walk-behind and ride-on floor scrubbers for hard-floor care.' },
    { id: 'starter-business-packages', name: 'Starter Business Packages', url: '/pages/starter-business-packages', imageLabel: 'Starter Package', description: 'Launch packages for new cleaning businesses and first commercial accounts.' }
  ];

  var WIREFRAME_FACILITY_OPTIONS = [
    { sublabel: 'Office building cleaning', label: 'Commercial Buildings', value: 'office', icon: 'office', photoKey: 'office' },
    { sublabel: 'Warehouse floor cleaning', label: 'Warehouses / Distribution', value: 'warehouse', icon: 'warehouse', photoKey: 'warehouse' },
    { sublabel: 'School cleaning', label: 'Schools / Education', value: 'school', icon: 'school', photoKey: 'school' },
    { sublabel: 'Healthcare facility cleaning', label: 'Healthcare / Medical', value: 'healthcare', icon: 'healthcare', photoKey: 'healthcare' },
    { sublabel: 'Property management cleaning', label: 'Retail Stores', value: 'property_manager', icon: 'property', photoKey: 'retail' },
    { sublabel: 'Gym floor cleaning', label: 'Gym / Fitness Center', value: 'gym', icon: 'gym', photoKey: 'gym' },
    { sublabel: 'Help me decide', label: 'Not sure yet', value: 'not_sure', icon: 'help' },
    { sublabel: 'Other facility type', label: 'Other / Not Listed', value: 'other', icon: 'help' }
  ];

  var WIREFRAME_STEPS = [
    { id: 'facility', title: 'What type of facility are you cleaning?' },
    { id: 'task', title: 'What type of surface are you cleaning?' },
    { id: 'equipment', title: 'What is your primary cleaning task?' },
    { id: 'size', title: 'What is the approximate area size?' },
    { id: 'power', title: 'What power source do you prefer?', custom: 'power' },
    { id: 'frequency', title: 'How often will the equipment be used?', custom: 'frequency' }
  ];

  var WIREFRAME_POWER_OPTIONS = [
    { label: 'Battery powered', value: 'battery', icon: 'scrubber' },
    { label: 'Corded electric', value: 'corded', icon: 'equipment' },
    { label: 'Propane / gas', value: 'propane', icon: 'warehouse' },
    { label: 'No preference', value: 'either', icon: 'help' }
  ];

  var WIREFRAME_FREQUENCY_OPTIONS = [
    { label: 'Daily', value: 'daily' },
    { label: 'Several times per week', value: 'several_weekly' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Occasional / as needed', value: 'occasional' }
  ];

  var WIREFRAME_BRAND_OPTIONS = [
    { label: 'Any brand', value: '' },
    { label: 'Tennant', value: 'tennant' },
    { label: 'Clarke / Nilfisk', value: 'clarke' },
    { label: 'CleanFreak / TCB', value: 'cleanfreak' },
    { label: 'Advance', value: 'advance' },
    { label: 'Mytee', value: 'mytee' }
  ];

  var BROWSE_PACKAGES = [
    { id: 'school-cleaning-packages', icon: 'school', name: 'School Cleaning Packages', url: '/pages/school-cleaning-packages', description: 'Hallways, classrooms, restrooms, and full school setups.' },
    { id: 'church-cleaning-packages', icon: 'church', name: 'Church Cleaning Packages', url: '/pages/church-cleaning-packages', description: 'Sanctuaries, fellowship halls, restrooms, and event cleanup.' },
    { id: 'gym-cleaning-packages', icon: 'gym', name: 'Gym Cleaning Packages', url: '/pages/gym-cleaning-packages', description: 'Rubber floors, locker rooms, odor control, and fitness areas.' },
    { id: 'restaurant-cleaning-packages', icon: 'kitchen', name: 'Restaurant Cleaning Packages', url: '/pages/restaurant-cleaning-packages', description: 'Kitchen degreasing, dining rooms, restrooms, and safety.' },
    { id: 'warehouse-cleaning-packages', icon: 'warehouse', name: 'Warehouse Cleaning Packages', url: '/pages/warehouse-cleaning-packages', description: 'Concrete floors, sweepers, scrubbers, and industrial cleanup.' },
    { id: 'hotel-cleaning-packages', icon: 'hotel', name: 'Hotel & Property Packages', url: '/pages/hotel-cleaning-packages', description: 'Guest rooms, carpets, housekeeping carts, and lobbies.' },
    { id: 'property-manager-cleaning-packages', icon: 'property', name: 'Property Manager Packages', url: '/pages/property-manager-cleaning-packages', description: 'Apartment turns, common areas, and carpet care.' },
    { id: 'office-cleaning-packages', icon: 'office', name: 'Office Building Packages', url: '/pages/office-cleaning-packages', description: 'Offices, lobbies, restrooms, and daily janitorial routes.' },
    { id: 'healthcare-cleaning-packages', icon: 'healthcare', name: 'Healthcare Packages', url: '/pages/healthcare-cleaning-packages', description: 'Clinics, restrooms, waiting rooms, and patient areas.' },
    { id: 'contractor-cleaning-packages', icon: 'contractor', name: 'Contractor Packages', url: '/pages/contractor-cleaning-packages', description: 'Multi-surface routes, carpet, and hard-floor packages.' },
    { id: 'starter-business-packages', icon: 'startup', name: 'Starter Business Packages', url: '/pages/starter-business-packages', description: 'First accounts, solo cleaners, and launch setups.' },
    { id: 'carpet-extractor-packages', icon: 'extractor', name: 'Carpet Extractor Packages', url: '/pages/carpet-extractor-packages', description: 'Carpet cleaning machines, hoses, chemicals, and tools.' },
    { id: 'floor-scrubber-packages', icon: 'scrubber', name: 'Floor Scrubber Packages', url: '/pages/floor-scrubber-packages', description: 'Scrubber-focused packages for schools, gyms, and warehouses.' },
    { id: 'packages-hub', icon: 'package', name: 'All Custom Equipment Packages', url: '/pages/packages', description: 'Browse every custom package hub and request a quote.', featured: true }
  ];

  function getAssets() {
    return window.TCB_FINDER_ASSETS || {};
  }

  function esc(v) {
    return String(v || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function getData() {
    return window.TCB_FINDER_DATA || { products: [], packages: [], productDescriptions: {}, packageDescriptions: {} };
  }

  function normalizeFinderQuoteUrl(url) {
    var fallback = '/pages/contact?topic=equipment-finder#tcb-finder-lead-form';
    if (!url) return fallback;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.pathname === '/contact' || parsed.pathname.endsWith('/contact')) {
        parsed.pathname = '/pages/contact';
      }
      if (parsed.hash === '#tcb-finder-lead-form' || !parsed.hash) {
        parsed.hash = 'tcb-finder-lead-form';
      }
      if (!parsed.searchParams.get('topic')) {
        parsed.searchParams.set('topic', 'equipment-finder');
      }
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      return fallback;
    }
  }

  function wantsPackageFirst(answers) {
    return answers.intent === 'complete_package' || answers.equipment === 'complete_package';
  }

  function normalizeAnswers(answers) {
    if (Array.isArray(answers.task)) return answers;
    if (answers.task && typeof answers.task === 'string') {
      answers.task = [answers.task];
    } else if (!answers.task) {
      answers.task = [];
    }
    return answers;
  }

  function isOptionSelected(q, value, answers) {
    if (q.multi) {
      return Array.isArray(answers[q.id]) && answers[q.id].indexOf(value) !== -1;
    }
    return answers[q.id] === value;
  }

  function hasAnswer(q, answers) {
    if (q.multi) return Array.isArray(answers[q.id]) && answers[q.id].length > 0;
    return !!answers[q.id];
  }

  function buildTags(answers) {
    answers = normalizeAnswers(Object.assign({}, answers));
    var tags = [];
    Object.keys(answers).forEach(function (key) {
      var val = answers[key];
      if (Array.isArray(val)) {
        val.forEach(function (item) {
          if (item && item !== 'not_sure') tags.push(item);
        });
      } else if (val && val !== 'not_sure') {
        tags.push(val);
      }
    });
    if (answers.size === '5000_25000' || answers.size === '25000_75000') tags.push('small_medium');
    if (answers.intent === 'complete_package') tags.push('complete_package');
    return tags.filter(function (t, i, arr) { return arr.indexOf(t) === i; });
  }

  function scoreItem(item, tags, answers) {
    var score = 0;
    var bestFor = item.bestFor || [];
    tags.forEach(function (tag) {
      if (bestFor.indexOf(tag) !== -1) score += 10;
    });
    if (answers.facility && item.facility === answers.facility) score += 28;
    if (item.facility === 'all') score += 3;
    if (answers.equipment && bestFor.indexOf(answers.equipment) !== -1) score += 32;
    if (answers.equipment && EQUIPMENT_PRODUCT_IDS[answers.equipment]) {
      if (EQUIPMENT_PRODUCT_IDS[answers.equipment].indexOf(item.id) !== -1) score += 40;
    }
    if (Array.isArray(answers.task)) {
      answers.task.forEach(function (task) {
        if (bestFor.indexOf(task) !== -1) score += 14;
      });
    } else if (answers.task && bestFor.indexOf(answers.task) !== -1) {
      score += 14;
    }
    if (answers.size === '75000_plus' || answers.size === 'multiple') {
      if (bestFor.indexOf('large') !== -1 || bestFor.indexOf('75000_plus') !== -1 || bestFor.indexOf('multiple') !== -1) score += 12;
    }
    if (answers.budget === 'under_1000') {
      if (bestFor.indexOf('starter') !== -1 || bestFor.indexOf('under_1000') !== -1 || bestFor.indexOf('chemicals') !== -1 || bestFor.indexOf('parts') !== -1) score += 14;
    }
    if (answers.budget === '7500_15000' || answers.budget === '15000_plus') {
      if (bestFor.indexOf('professional') !== -1 || bestFor.indexOf('entire_facility') !== -1) score += 14;
      if (bestFor.indexOf(answers.budget) !== -1) score += 18;
    }
    if (item.type === 'product' && item.price) {
      if (answers.budget === '15000_plus' && item.price >= 15000) score += 28;
      else if (answers.budget === '7500_15000' && item.price >= 7500 && item.price < 20000) score += 22;
      else if (answers.budget === '3000_7500' && item.price >= 3000 && item.price < 7500) score += 16;
    }
    if (item.type === 'product' && item.url && item.url.indexOf('/products/') === 0) {
      if (answers.intent === 'show_equipment') score += 18;
    }
    if (answers.intent === 'complete_package' && item.url && item.url.indexOf('/pages/') === 0) score += 16;
    if (answers.intent === 'show_equipment' && item.url && item.url.indexOf('/collections/') === 0) score += 8;
    if (item.searchKeywords) {
      var kw = String(item.searchKeywords).toLowerCase();
      tags.forEach(function (tag) {
        if (kw.indexOf(tag) !== -1) score += 8;
      });
    }
    if (item.sku && answers.skuQuery && item.sku.toLowerCase().indexOf(String(answers.skuQuery).toLowerCase()) !== -1) score += 50;
    return score;
  }

  function dedupeByUrl(items) {
    var seen = new Set();
    return items.filter(function (item) {
      if (!item || !item.url || seen.has(item.url)) return false;
      seen.add(item.url);
      return true;
    });
  }

  var PRODUCT_IMAGE_GALLERY_KEYS = {
    'walk-behind-floor-scrubbers': 'floor-scrubbers',
    'ride-on-floor-scrubbers': 'floor-scrubbers',
    'wet-dry-vacuums': 'commercial-vacuums',
    'floor-buffers': 'floor-buffers',
    burnishers: 'burnishers',
    'industrial-cleaning-equipment': 'industrial-cleaning-equipment',
    parts: 'parts',
    chemicals: 'chemicals'
  };

  function resolveProductImageUrl(item) {
    var assets = getAssets();
    var gallery = assets.gallery || {};
    var galleryKey = PRODUCT_IMAGE_GALLERY_KEYS[item.id] || item.id;
    if (gallery[galleryKey]) return gallery[galleryKey];
    var products = assets.products || {};
    if (products[item.id]) return products[item.id];
    return '';
  }

  function getPackageHeroIndex() {
    return window.TCB_PACKAGE_HERO_INDEX || { by_id: {}, by_handle: {}, titles: {} };
  }

  function packageHeroAssetUrl(filename) {
    if (!filename) return '';
    var assets = getAssets();
    var sample = assets.packageHeroSample || assets.defaultPackage;
    if (!sample) return '';
    return sample.replace('package-hero-default.jpg', filename);
  }

  function pageHandleFromItem(item) {
    if (!item) return '';
    if (item.url && item.url.indexOf('/pages/') === 0) {
      return item.url.replace(/^\/pages\//, '').split(/[?#]/)[0];
    }
    return item.id || '';
  }

  function categoryImageAlt(item) {
    return (item.name || 'Equipment category') + ' — commercial cleaning equipment category photo';
  }

  function packageImageAlt(item) {
    var index = getPackageHeroIndex();
    var handle = pageHandleFromItem(item);
    var title = (index.titles && (index.titles[handle] || index.titles[item.id])) || item.name || 'Equipment package';
    return 'Commercial cleaning equipment package: ' + title;
  }

  function resolvePackageImageUrl(item) {
    var assets = getAssets();
    var packages = assets.packages || {};
    if (packages[item.id]) return packages[item.id];

    var index = getPackageHeroIndex();
    var file = (index.by_id && index.by_id[item.id]) || (index.by_handle && index.by_handle[pageHandleFromItem(item)]);
    if (file) return packageHeroAssetUrl(file);

    var prefixes = [
      ['school', 'school-cleaning-packages'],
      ['church', 'church-cleaning-packages'],
      ['gym', 'gym-cleaning-packages'],
      ['restaurant', 'restaurant-cleaning-packages'],
      ['warehouse', 'warehouse-cleaning-packages'],
      ['hotel', 'hotel-cleaning-packages'],
      ['property', 'property-manager-cleaning-packages'],
      ['office', 'office-cleaning-packages'],
      ['healthcare', 'healthcare-cleaning-packages'],
      ['contractor', 'contractor-cleaning-packages'],
      ['startup', 'starter-business-packages'],
      ['carpet-extractor', 'carpet-extractor-packages'],
      ['floor-scrubber', 'floor-scrubber-packages'],
      ['scrubber', 'floor-scrubber-packages']
    ];
    for (var i = 0; i < prefixes.length; i++) {
      if (item.id.indexOf(prefixes[i][0]) !== -1 && packages[prefixes[i][1]]) {
        return packages[prefixes[i][1]];
      }
    }
    if (assets.defaultPackage) return assets.defaultPackage;
    return '';
  }

  function enrichItem(item, kind, data) {
    if (!item) return null;
    var description = item.description || (kind === 'product'
      ? (data.productDescriptions || {})[item.id]
      : (data.packageDescriptions || {})[item.id]) || '';
    var imageLabel = item.imageLabel || item.name;
    var imageUrl = item.imageUrl || item.image || '';
    if (kind === 'product' && !imageUrl) {
      imageUrl = resolveProductImageUrl(item);
    }
    if (kind === 'package' && !imageUrl) {
      imageUrl = resolvePackageImageUrl(item);
    }
    return Object.assign({}, item, {
      description: description,
      imageLabel: imageLabel,
      imageUrl: imageUrl
    });
  }

  function padRecommendations(items, fallbacks, kind, data, targetCount) {
    targetCount = targetCount || RECOMMENDATION_TOTAL;
    var list = dedupeByUrl(items.slice());

    function hasUrl(url) {
      return list.some(function (x) { return x.url === url; });
    }

    fallbacks.forEach(function (fb) {
      if (list.length >= targetCount) return;
      if (hasUrl(fb.url)) return;
      list.push(enrichItem(fb, kind, data));
    });

    if (list.length < targetCount) {
      var pool = kind === 'product' ? data.products || [] : data.packages || [];
      pool.forEach(function (raw) {
        if (list.length >= targetCount) return;
        if (!raw || !raw.url || hasUrl(raw.url)) return;
        list.push(enrichItem(Object.assign({}, raw), kind, data));
      });
    }

    return list.slice(0, targetCount);
  }

  function rankRecommendations(items, fallbacks, kind, data, targetCount, answers) {
    targetCount = targetCount || RECOMMENDATION_TOTAL;
    var minScore = kind === 'package' ? 20 : 18;
    var ranked = dedupeByUrl(items.filter(function (item) { return item.score >= minScore; }));
    if (ranked.length < 4) {
      ranked = dedupeByUrl(items.filter(function (item) { return item.score > 0; }));
    }
    ranked.sort(function (a, b) { return b.score - a.score; });
    if (ranked.length < targetCount) {
      ranked = padRecommendations(ranked, fallbacks, kind, data, targetCount);
    } else {
      ranked = ranked.slice(0, targetCount);
    }
    return ranked;
  }

  function getRecommendations(answers) {
    answers = normalizeAnswers(answers);
    var data = getData();
    var tags = buildTags(answers);
    var products = (data.products || []).map(function (p) {
      return enrichItem(Object.assign({}, p, { score: scoreItem(p, tags, answers) }), 'product', data);
    }).sort(function (a, b) { return b.score - a.score; });

    var packages = (data.packages || []).map(function (p) {
      return enrichItem(Object.assign({}, p, { score: scoreItem(p, tags, answers) }), 'package', data);
    }).sort(function (a, b) { return b.score - a.score; });

    var rankedProducts = rankRecommendations(products, PRODUCT_FALLBACKS, 'product', data, RECOMMENDATION_TOTAL, answers);
    var rankedPackages = rankRecommendations(packages, PACKAGE_FALLBACKS, 'package', data, RECOMMENDATION_TOTAL, answers);

    return {
      products: rankedProducts,
      packages: rankedPackages,
      tags: tags,
      usedRefurbNote: answers.condition === 'used' || answers.condition === 'either'
    };
  }

  function buildReasonText(answers) {
    var parts = [];
    var facility = labelForQuestion('facility', answers.facility);
    var task = labelForQuestion('task', answers.task);
    var equipment = labelForQuestion('equipment', answers.equipment);
    var size = labelForQuestion('size', answers.size);
    if (facility) parts.push(facility.toLowerCase() + ' facility needs');
    if (task) parts.push(task.toLowerCase());
    if (equipment) parts.push(equipment.toLowerCase());
    if (size) parts.push(size.toLowerCase() + ' area size');
    if (!parts.length) return 'Matched to your equipment finder answers.';
    if (parts.length === 1) return 'Matched to your ' + parts[0] + '.';
    return 'Matched to your ' + parts.slice(0, -1).join(', ') + ', and ' + parts[parts.length - 1] + '.';
  }

  function buildItemReasonText(item, answers) {
    var reasons = [];
    var bestFor = item.bestFor || [];

    if (answers.facility && item.facility === answers.facility) {
      reasons.push('purpose-built for ' + labelForQuestion('facility', answers.facility).toLowerCase() + ' facilities');
    }
    if (answers.equipment && bestFor.indexOf(answers.equipment) !== -1) {
      reasons.push('aligned with your ' + labelForQuestion('equipment', answers.equipment).toLowerCase() + ' selection');
    }
    if (Array.isArray(answers.task)) {
      answers.task.forEach(function (task) {
        if (task && bestFor.indexOf(task) !== -1) {
          reasons.push('supports ' + labelForQuestion('task', task).toLowerCase());
        }
      });
    } else if (answers.task && bestFor.indexOf(answers.task) !== -1) {
      reasons.push('supports ' + labelForQuestion('task', answers.task).toLowerCase());
    }
    if (answers.budget && bestFor.indexOf(answers.budget) !== -1) {
      reasons.push('fits your ' + labelForQuestion('budget', answers.budget).toLowerCase() + ' budget');
    }
    if (answers.size && (bestFor.indexOf(answers.size) !== -1 || bestFor.indexOf('large') !== -1 && (answers.size === '75000_plus' || answers.size === 'multiple'))) {
      reasons.push('suited to ' + labelForQuestion('size', answers.size).toLowerCase());
    }

    if (!reasons.length) {
      return buildReasonText(answers);
    }
    return reasons.slice(0, 3).join('; ') + '.';
  }

  function renderResultMedia(item, type, eager) {
    var alt = type === 'package' ? packageImageAlt(item) : categoryImageAlt(item);
    if (item.imageUrl) {
      var url = item.imageUrl;
      var srcset = '';
      if ((/\.png(\?|$)/i.test(url) || /\.jpe?g(\?|$)/i.test(url)) && !/\.webp(\?|$)/i.test(url)) {
        srcset = ' srcset="' + esc(assetSizedUrl(url, 320)) + ' 320w, ' + esc(assetSizedUrl(url, 480)) + ' 480w, ' + esc(assetSizedUrl(url, 640)) + ' 640w, ' + esc(assetSizedUrl(url, 960)) + ' 960w" sizes="(max-width: 640px) 88px, 320px"';
      }
      return '<img src="' + esc(url) + '"' + srcset + ' alt="' + esc(alt) + '" loading="' + (eager ? 'eager' : 'lazy') + '" decoding="async" width="640" height="360">';
    }
    return '<div class="tcb-result-placeholder">' + esc(item.imageLabel || item.name) + '</div>';
  }

  function renderResultCard(item, type, reason, ctaText, featured) {
    if (!item) return '';
    var badge = featured
      ? (type === 'product' ? 'Best Match' : 'Best Package Match')
      : (type === 'product' ? 'Product Match' : 'Package Match');
    var seeAll = type === 'product'
      ? '<a class="tcb-result-see-all" href="' + esc(item.url) + '">See all ' + esc(item.name.toLowerCase()) + ' →</a>'
      : '<a class="tcb-result-see-all" href="' + esc(item.url) + '">View packages →</a>';
    return (
      '<article class="tcb-result-card' + (featured ? ' tcb-result-card--featured' : '') + '">' +
        '<div class="tcb-result-badge">' + esc(badge) + '</div>' +
        '<a href="' + esc(item.url) + '" class="tcb-result-media tcb-result-media-link" aria-label="View ' + esc(item.name) + '">' +
          renderResultMedia(item, type) +
        '</a>' +
        '<div class="tcb-result-body">' +
          '<h4>' + esc(item.name) + '</h4>' +
          '<p>' + esc(item.description) + '</p>' +
          '<p class="tcb-result-reason"><strong>Why it fits:</strong> ' + esc(reason) + '</p>' +
          '<a href="' + esc(item.url) + '" class="tcb-page-btn tcb-page-btn--primary">' + esc(ctaText) + ' →</a>' +
          (featured ? seeAll : '') +
        '</div>' +
      '</article>'
    );
  }

  function renderGalleryCard(item) {
    var assets = getAssets().gallery || {};
    var img = assets[item.key] || '';
    var alt = item.name + ' — commercial cleaning equipment category photo';
    var media = img
      ? '<img src="' + esc(img) + '" alt="' + esc(alt) + '" loading="lazy" width="320" height="240" decoding="async">'
      : '<div class="tcb-result-placeholder">' + esc(item.name) + '</div>';
    return (
      '<a class="tcb-result-browse-card tcb-result-browse-card--gallery" href="' + esc(item.url) + '">' +
        '<div class="tcb-result-media tcb-result-media--compact tcb-result-media--photo">' + media + '</div>' +
        '<strong>' + esc(item.name) + '</strong>' +
      '</a>'
    );
  }

  function renderBrowseCard(item) {
    var assets = getAssets();
    var packages = assets.packages || {};
    var hero = packages[item.id] || '';
    var iconSource = resolveIconSource(item.icon || 'package');
    var iconSrc = iconSource ? assetSizedUrl(iconSource.primary, 112) : '';
    var iconFallback = iconSource && iconSource.fallback !== iconSource.primary
      ? assetSizedUrl(iconSource.fallback, 112)
      : '';
    var cardClass = 'tcb-finder-facility-card' + (item.featured ? ' tcb-finder-facility-card--featured' : '');
    var media = '';

    if (hero) {
      media =
        '<div class="tcb-finder-facility-card__media">' +
          '<img class="tcb-finder-facility-card__hero" src="' + esc(hero) + '" alt="' + esc(item.name + ' — commercial cleaning package photo') + '" loading="eager" decoding="async" width="480" height="270">' +
          (iconSrc
            ? '<span class="tcb-finder-facility-card__icon tcb-finder-facility-card__icon--overlay" aria-hidden="true">' +
                '<img src="' + esc(iconSrc) + '" alt="" width="56" height="56" loading="eager" decoding="async" ' +
                (iconFallback ? 'data-fallback-src="' + esc(iconFallback) + '" onerror="window.TCBFinderIconFallback&&window.TCBFinderIconFallback(this)"' : '') +
                '>' +
              '</span>'
            : '') +
        '</div>';
    } else if (iconSrc) {
      media =
        '<div class="tcb-finder-facility-card__media">' +
          '<span class="tcb-finder-facility-card__icon" aria-hidden="true">' +
            '<img src="' + esc(iconSrc) + '" alt="" width="72" height="72" loading="lazy" decoding="async" ' +
            'data-fallback-src="' + esc(iconFallback) + '" onerror="window.TCBFinderIconFallback&&window.TCBFinderIconFallback(this)">' +
          '</span>' +
        '</div>';
    }

    return (
      '<a class="' + cardClass + '" href="' + esc(item.url) + '" role="listitem">' +
        media +
        '<div class="tcb-finder-facility-card__body">' +
          '<h3 class="tcb-finder-facility-card__title">' + esc(item.name) + '</h3>' +
          '<p class="tcb-finder-facility-card__desc">' + esc(item.description) + '</p>' +
          '<span class="tcb-finder-facility-card__link">' +
            'View Packages' +
            '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>' +
        '</div>' +
      '</a>'
    );
  }

  function labelForQuestion(id, value) {
    if (value === undefined || value === null) return '';
    var q = QUESTIONS.find(function (item) { return item.id === id; });
    if (!q) return String(value);
    if (Array.isArray(value)) {
      return value.map(function (v) {
        var opt = q.options.find(function (item) { return item.value === v; });
        return opt ? opt.label : v;
      }).join(', ');
    }
    var opt = q.options.find(function (item) { return item.value === value; });
    return opt ? opt.label : value;
  }

  function assetSizedUrl(url, width) {
    if (!url) return '';
    if (/\.webp(\?|$)/i.test(url)) return url;
    var queryIndex = url.indexOf('?');
    var query = queryIndex >= 0 ? url.slice(queryIndex) : '';
    var path = queryIndex >= 0 ? url.slice(0, queryIndex) : url;
    path = path.replace(/_(\d+x\d+|\d+x)(?=\.[a-z]+$)/i, '');
    path = path.replace(/(\.[a-z]+)$/i, '_' + width + 'x$1');
    return path + query;
  }

  function getFacilityPhoto(key) {
    if (!key) return '';
    var photos = getAssets().facilityPhotos || {};
    return photos[key] || '';
  }

  function wireframeStepAnswered(stepConfig, answers) {
    if (stepConfig.custom === 'power') return !!answers.power;
    if (stepConfig.custom === 'frequency') return !!answers.frequency;
    if (stepConfig.id === 'task') {
      return (Array.isArray(answers.task) && answers.task.length > 0) || !!answers.task;
    }
    var q = QUESTIONS.find(function (item) { return item.id === stepConfig.id; });
    if (!q) return false;
    return hasAnswer(q, answers);
  }

  function computeWireframeStep(answers) {
    for (var i = 0; i < WIREFRAME_STEPS.length; i++) {
      if (!wireframeStepAnswered(WIREFRAME_STEPS[i], answers)) return i;
    }
    return WIREFRAME_STEPS.length - 1;
  }

  function wireframeQuizComplete(answers) {
    return WIREFRAME_STEPS.every(function (step) {
      return wireframeStepAnswered(step, answers);
    });
  }

  function facilityPhotoHtml(url) {
    if (!url) return '';
    var srcset = '';
    if (/\.png(\?|$)/i.test(url)) {
      srcset = ' srcset="' + esc(assetSizedUrl(url, 320)) + ' 320w, ' +
        esc(assetSizedUrl(url, 480)) + ' 480w, ' +
        esc(assetSizedUrl(url, 640)) + ' 640w, ' +
        esc(assetSizedUrl(url, 960)) + ' 960w" sizes="(max-width: 640px) 46vw, 220px"';
    }
    return (
      '<span class="tcb-finder-photo">' +
        '<img src="' + esc(url) + '"' + srcset + ' alt="" width="320" height="180" loading="eager" decoding="async">' +
      '</span>'
    );
  }

  function resolveIconSource(name) {
    var sources = getAssets().iconSources || getAssets().icons || {};
    var entry = sources[name];
    if (!entry) return null;
    if (typeof entry === 'string') {
      return { primary: entry, fallback: entry, alt: '', sized: /\.png(\?|$)/i.test(entry) };
    }
    var hd = entry.hd || '';
    var fallback = entry.fallback || hd || '';
    var hdIsMislabeledJpeg = /\.webp(\?|$)/i.test(hd);
    var primary = hdIsMislabeledJpeg ? hd : (fallback || hd);
    return {
      primary: primary,
      fallback: fallback || hd,
      alt: entry.alt || '',
      sized: !hdIsMislabeledJpeg && /\.png(\?|$)/i.test(primary)
    };
  }

  function iconHtml(name, variant) {
    var source = resolveIconSource(name);
    if (!source || !source.primary) {
      return '<span class="tcb-finder-icon tcb-finder-icon--fallback" aria-hidden="true"></span>';
    }
    var isGrid = variant === 'grid';
    var cls = 'tcb-finder-icon' + (isGrid ? ' tcb-finder-icon--grid' : ' tcb-finder-icon--list');
    var display = isGrid ? 96 : 40;
    var loading = isGrid ? 'eager' : 'lazy';
    if (!source.sized) {
      return (
        '<span class="' + cls + '">' +
          '<img src="' + esc(source.primary) + '" data-fallback-src="' + esc(source.fallback || source.primary) + '" ' +
          'alt="' + esc(source.alt) + '" width="' + display + '" height="' + display + '" loading="' + loading + '" decoding="async" ' +
          'onerror="window.TCBFinderIconFallback&&window.TCBFinderIconFallback(this)">' +
        '</span>'
      );
    }
    var widths = isGrid ? [96, 128, 192, 256] : [48, 64, 96, 128];
    var src = assetSizedUrl(source.primary, widths[1] || widths[0]);
    var fallbackSrc = assetSizedUrl(source.fallback, widths[1] || widths[0]);
    var srcset = widths.map(function (w) {
      return assetSizedUrl(source.primary, w) + ' ' + w + 'w';
    }).join(', ');
    var fallbackSrcset = widths.map(function (w) {
      return assetSizedUrl(source.fallback, w) + ' ' + w + 'w';
    }).join(', ');
    var sizes = isGrid
      ? '(max-width: 640px) 72px, (max-width: 1024px) 84px, 96px'
      : '40px';
    return (
      '<span class="' + cls + '">' +
        '<img src="' + esc(src) + '" srcset="' + esc(srcset) + '" sizes="' + sizes + '" ' +
        'data-fallback-src="' + esc(fallbackSrc) + '" data-fallback-srcset="' + esc(fallbackSrcset) + '" ' +
        'alt="' + esc(source.alt) + '" width="' + display + '" height="' + display + '" loading="' + loading + '" decoding="async" ' +
        'onerror="window.TCBFinderIconFallback&&window.TCBFinderIconFallback(this)">' +
      '</span>'
    );
  }

  window.TCBFinderIconFallback = function (img) {
    if (!img || img.dataset.fallbackApplied === '1') return;
    img.dataset.fallbackApplied = '1';
    if (img.dataset.fallbackSrc) img.src = img.dataset.fallbackSrc;
    if (img.dataset.fallbackSrcset) img.srcset = img.dataset.fallbackSrcset;
  };

  function renderProgress(stepIndex, totalSteps) {
    var count = totalSteps || TOTAL_STEPS;
    var html = '';
    for (var i = 0; i < count; i++) {
      var cls = 'tcb-finder-progress__circle';
      if (i < stepIndex) cls += ' is-complete';
      if (i <= stepIndex) cls += ' is-active';
      html += '<span class="' + cls + '"></span>';
    }
    return html;
  }

  function renderOptionButton(q, option, answers) {
    var selected = isOptionSelected(q, option.value, answers);
    var grid = q.type === 'grid';
    var photoUrl = grid && option.photoKey ? getFacilityPhoto(option.photoKey) : '';
    var cls = 'tcb-finder-option' + (grid ? ' tcb-finder-option--grid' : ' tcb-finder-option--list') + (photoUrl ? ' tcb-finder-option--photo' : '') + (selected ? ' is-selected' : '');
    var labelHtml = option.sublabel
      ? '<span class="tcb-finder-option__text">' +
          '<span class="tcb-finder-option__sublabel">' + esc(option.sublabel) + '</span>' +
          '<span class="tcb-finder-option__label">' + esc(option.label) + '</span>' +
        '</span>'
      : '<span class="tcb-finder-option__label">' + esc(option.label) + '</span>';
    var mediaHtml = photoUrl
      ? facilityPhotoHtml(photoUrl)
      : (option.icon ? iconHtml(option.icon, grid ? 'grid' : 'list') : '');
    return (
      '<button type="button" class="' + cls + '" data-value="' + esc(option.value) + '">' +
        mediaHtml +
        labelHtml +
        (selected ? '<span class="tcb-finder-option__check" aria-hidden="true">✓</span>' : '') +
      '</button>'
    );
  }

  function renderNote(note) {
    if (!note) return '';
    var icon = note.icon === 'dollar' ? '$' : 'i';
    return (
      '<div class="tcb-finder-note">' +
        '<span class="tcb-finder-note__icon" aria-hidden="true">' + icon + '</span>' +
        '<p>' + esc(note.text) + '</p>' +
      '</div>'
    );
  }

  function renderPreviewCard(item, type, quoteUrl) {
    if (!item) return '';
    var stars = '★★★★★';
    var price = item.priceLabel || 'From shop pricing';
    var ctaProduct = type === 'product' ? 'View Product' : 'View Package';
    return (
      '<article class="tcb-ef-preview-card">' +
        '<a href="' + esc(item.url) + '" class="tcb-ef-preview-card__media">' +
          renderResultMedia(item, type, true) +
        '</a>' +
        '<div class="tcb-ef-preview-card__body">' +
          '<h3><a href="' + esc(item.url) + '">' + esc(item.name) + '</a></h3>' +
          '<p>' + esc(item.description || '') + '</p>' +
          '<p class="tcb-ef-preview-card__meta">' +
            '<span class="tcb-ef-preview-card__price">' + esc(price) + '</span>' +
            '<span class="tcb-ef-preview-card__stars" aria-hidden="true">' + stars + '</span>' +
          '</p>' +
          '<div class="tcb-ef-preview-card__actions">' +
            '<a class="tcb-page-btn tcb-page-btn--secondary tcb-page-btn--compact" href="' + esc(item.url) + '">' + esc(ctaProduct) + '</a>' +
            '<a class="tcb-page-btn tcb-page-btn--quote tcb-page-btn--compact" href="' + esc(quoteUrl) + '">Add to Quote</a>' +
          '</div>' +
        '</div>' +
      '</article>'
    );
  }

  function FinderApp(root) {
    this.root = root;
    this.layout = root.getAttribute('data-page-layout') || 'classic';
    this.step = 0;
    this.answers = { task: [] };
    this.results = null;
    this.leadSubmitted = false;
    this.quoteUrl = normalizeFinderQuoteUrl(root.getAttribute('data-quote-url'));
    this.packagesUrl = root.getAttribute('data-packages-url') || '/collections/custom-equipment-packages';
    this.flowMount = root.querySelector('[data-tcb-finder-flow]');
    this.resultsMount = root.querySelector('[data-tcb-finder-results]');
    this.shellMount = root.querySelector('[data-tcb-finder-shell]');
    this.previewList = root.querySelector('[data-tcb-finder-preview-list]');
    this.leadForm = root.querySelector('#tcb-finder-lead-capture')
      || root.querySelector('#tcb-finder-lead-form');
    this.wireframeOpenStep = 0;
    if (this.layout === 'wireframe' && window.tcbAnalytics) window.tcbAnalytics.finderStarted();
    this.bindLeadForm();
    this.bindHero();
    this.bindEmailExpertButtons();
    this.restore();
    this.render();
  }

  FinderApp.prototype.bindLeadForm = function () {
    if (!this.leadForm || this.leadForm.dataset.boundLeadCapture) return;
    this.leadForm.dataset.boundLeadCapture = '1';
    this.leadForm.removeAttribute('action');
    this.leadForm.addEventListener('submit', function (event) {
      event.preventDefault();
    });
  };

  FinderApp.prototype.bindEmailExpertButtons = function () {
    if (this.root.dataset.boundEmailExpert) return;
    this.root.dataset.boundEmailExpert = '1';
    var self = this;
    this.root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-email-expert]');
      if (!btn || !self.root.contains(btn)) return;
      event.preventDefault();
      event.stopPropagation();
      self.emailExpertToContact();
    }, true);
  };

  FinderApp.prototype.bindHero = function () {
    var self = this;
    rootQuery(this.root, '[data-tcb-finder-start]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = self.root.querySelector('#tcb-finder-flow');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else if (self.shellMount) self.shellMount.scrollIntoView({ behavior: 'smooth', block: 'start' });
        self.step = 0;
        self.render();
        if (window.tcbAnalytics) window.tcbAnalytics.finderStarted();
      });
    });
  };

  FinderApp.prototype.restore = function () {
    try {
      var saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (saved && saved.answers) {
        this.answers = normalizeAnswers(saved.answers);
        if (this.layout === 'wireframe') {
          this.wireframeOpenStep = computeWireframeStep(this.answers);
          if (saved.showResults && wireframeQuizComplete(this.answers)) {
            this.results = getRecommendations(this.answers);
          } else {
            this.results = null;
          }
        } else if (saved.results) {
          this.results = getRecommendations(this.answers);
          this.step = QUESTIONS.length;
        }
      }
    } catch (e) { /* ignore */ }
  };

  FinderApp.prototype.persist = function () {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      answers: this.answers,
      results: !!this.results,
      showResults: !!this.results
    }));
  };

  FinderApp.prototype.setStaticFooterVisible = function (visible) {
    rootQuery(this.root, '.tcb-finder-facility-packages--static, .tcb-finder-help-band--static').forEach(function (el) {
      el.hidden = !visible;
    });
  };

  FinderApp.prototype.setShellVisible = function (visible) {
    if (this.shellMount) this.shellMount.hidden = !visible;
    var wireframeTool = this.root.querySelector('.tcb-ef-wireframe-tool');
    if (wireframeTool) wireframeTool.hidden = !visible;
    if (visible) {
      this.root.classList.remove('is-results');
      this.root.classList.remove('show-photos-intent');
    } else {
      this.root.classList.add('is-results');
      if (this.answers.intent === 'show_photos') {
        this.root.classList.add('show-photos-intent');
      } else {
        this.root.classList.remove('show-photos-intent');
      }
    }
  };

  FinderApp.prototype.updateLivePreview = function () {
    if (!this.previewList) return;
    if (!this.answers.facility) {
      this.previewList.innerHTML = '<p class="tcb-ef-wireframe-preview__empty">Select a facility type to see personalized matches.</p>';
      return;
    }
    var rec = getRecommendations(this.answers);
    var items = [];
    rec.products.slice(0, 3).forEach(function (p) { items.push({ item: p, type: 'product' }); });
    if (items.length < 4) {
      rec.packages.slice(0, 4 - items.length).forEach(function (p) { items.push({ item: p, type: 'package' }); });
    }
    if (!items.length) {
      this.previewList.innerHTML = '<p class="tcb-ef-wireframe-preview__empty">Select a facility type to see personalized matches.</p>';
      return;
    }
    this.previewList.innerHTML = items.map(function (entry) {
      return renderPreviewCard(entry.item, entry.type, this.quoteUrl);
    }, this).join('');
  };

  FinderApp.prototype.getWireframeQuestion = function (stepConfig) {
    if (stepConfig.id === 'facility') {
      return { id: 'facility', title: stepConfig.title, type: 'grid', selectionHint: 'Select one', options: WIREFRAME_FACILITY_OPTIONS };
    }
    if (stepConfig.custom === 'power') {
      return { id: 'power', title: stepConfig.title, type: 'grid', options: WIREFRAME_POWER_OPTIONS };
    }
    if (stepConfig.custom === 'frequency') {
      return { id: 'frequency', title: stepConfig.title, type: 'list', options: WIREFRAME_FREQUENCY_OPTIONS };
    }
    var q = QUESTIONS.find(function (item) { return item.id === stepConfig.id; });
    if (!q) return null;
    var overrides = { title: stepConfig.title || q.title };
    if (stepConfig.id === 'task') overrides.multi = false;
    return Object.assign({}, q, overrides);
  };

  FinderApp.prototype.updateWireframeSubmitState = function () {
    if (!this.flowMount) return;
    var complete = wireframeQuizComplete(this.answers);
    var submitBtn = this.flowMount.querySelector('[data-wireframe-submit]');
    var lead = this.flowMount.querySelector('.tcb-ef-wireframe-submit__lead');
    if (submitBtn) submitBtn.disabled = !complete;
    if (lead) {
      lead.textContent = complete
        ? 'Ready to see equipment matched to your answers?'
        : 'Answer all ' + WIREFRAME_STEPS.length + ' questions to unlock your recommendations.';
    }
  };

  FinderApp.prototype.submitWireframeResults = function () {
    if (!wireframeQuizComplete(this.answers)) {
      this.wireframeOpenStep = computeWireframeStep(this.answers);
      this.renderWireframeForm();
      var stepEl = this.flowMount && this.flowMount.querySelector('.tcb-ef-wireframe-step-active');
      if (stepEl) stepEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (!this.answers.intent) this.answers.intent = 'show_equipment';
    this.results = getRecommendations(this.answers);
    this.persist();
    if (window.tcbAnalytics) window.tcbAnalytics.finderCompleted(this.answers);
    this.render();
  };

  FinderApp.prototype.advanceWireframeStep = function () {
    if (this.wireframeOpenStep >= WIREFRAME_STEPS.length - 1) return;
    this.wireframeOpenStep += 1;
    this.renderWireframeForm();
    var stepEl = this.flowMount && this.flowMount.querySelector('.tcb-ef-wireframe-step-active');
    if (stepEl) stepEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  FinderApp.prototype.goBackWireframeStep = function () {
    if (this.wireframeOpenStep <= 0) return;
    this.wireframeOpenStep -= 1;
    this.renderWireframeForm();
    var stepEl = this.flowMount && this.flowMount.querySelector('.tcb-ef-wireframe-step-active');
    if (stepEl) stepEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  FinderApp.prototype.renderWireframeForm = function () {
    var self = this;
    if (!this.flowMount) return;
    this.flowMount.hidden = false;
    if (this.resultsMount) this.resultsMount.hidden = true;

    var stepConfig = WIREFRAME_STEPS[this.wireframeOpenStep];
    var q = this.getWireframeQuestion(stepConfig);
    if (!q) return;

    var optionsHtml = q.options.map(function (opt) {
      return renderOptionButton(q, opt, self.answers);
    }).join('');

    var isLastStep = this.wireframeOpenStep === WIREFRAME_STEPS.length - 1;
    var stepAnswered = hasAnswer(q, this.answers);

    var stepHtml =
      '<div class="tcb-ef-wireframe-step-active" data-wireframe-step="' + this.wireframeOpenStep + '">' +
        '<h2 class="tcb-ef-wireframe-step-active__title">' + esc(q.title) + '</h2>' +
        (q.selectionHint ? '<p class="tcb-finder-card__hint">' + esc(q.selectionHint) + '</p>' : '') +
        '<div class="tcb-finder-options tcb-finder-options--' + esc(q.type) + '" role="group" aria-label="' + esc(q.title) + '">' + optionsHtml + '</div>' +
        renderNote(q.note) +
        '<div class="tcb-finder-card__nav tcb-ef-wireframe-step__nav">' +
          (this.wireframeOpenStep > 0
            ? '<button type="button" class="tcb-finder-back" data-wireframe-back>← Back</button>'
            : '<span class="tcb-finder-back-spacer"></span>') +
          (isLastStep
            ? '<span class="tcb-finder-back-spacer"></span>'
            : '<button type="button" class="tcb-page-btn tcb-page-btn--primary tcb-finder-next" data-wireframe-next"' + (stepAnswered ? '' : ' disabled') + '>Next Question →</button>') +
        '</div>' +
      '</div>';

    var budgetOptions = QUESTIONS.find(function (item) { return item.id === 'budget'; });
    var budgetSelect = budgetOptions ? budgetOptions.options.map(function (opt) {
      var selected = self.answers.budget === opt.value ? ' selected' : '';
      return '<option value="' + esc(opt.value) + '"' + selected + '>' + esc(opt.label) + '</option>';
    }).join('') : '';

    this.flowMount.innerHTML =
      '<div class="tcb-ef-wireframe-form" id="tcb-finder-flow">' +
        '<div class="tcb-ef-wireframe-form__head">' +
          '<span class="tcb-finder-card__step">Step ' + (this.wireframeOpenStep + 1) + ' of ' + WIREFRAME_STEPS.length + '</span>' +
          '<div class="tcb-finder-progress" aria-hidden="true">' + renderProgress(this.wireframeOpenStep, WIREFRAME_STEPS.length) + '</div>' +
        '</div>' +
        stepHtml +
        '<div class="tcb-ef-wireframe-filters">' +
          '<label class="tcb-ef-wireframe-filter"><span>Budget Range</span><select data-wireframe-budget><option value="">Select budget (optional)</option>' + budgetSelect + '</select></label>' +
          '<label class="tcb-ef-wireframe-filter"><span>Preferred Brand</span><select data-wireframe-brand><option value="">Any brand (optional)</option>' +
            WIREFRAME_BRAND_OPTIONS.map(function (opt) {
              var selected = self.answers.preferred_brand === opt.value ? ' selected' : '';
              return '<option value="' + esc(opt.value) + '"' + selected + '>' + esc(opt.label) + '</option>';
            }).join('') +
          '</select></label>' +
        '</div>' +
        '<div class="tcb-ef-wireframe-altpaths" role="list">' +
          '<a class="tcb-ef-wireframe-altpaths__item" href="/collections/all" role="listitem"><strong>Browse All Equipment</strong><span>Shop the full catalog</span></a>' +
          '<a class="tcb-ef-wireframe-altpaths__item" href="' + esc(this.packagesUrl) + '" role="listitem"><strong>View Packages</strong><span>Complete facility setups</span></a>' +
          '<button type="button" class="tcb-ef-wireframe-altpaths__item tcb-ef-wireframe-altpaths__item--button" data-tcb-tidio-chat role="listitem"><strong>Talk to an Expert</strong><span>Live equipment help</span></button>' +
        '</div>' +
        '<div class="tcb-ef-wireframe-submit">' +
          '<p class="tcb-ef-wireframe-submit__lead">' + esc(wireframeQuizComplete(this.answers)
            ? 'Ready to see equipment matched to your answers?'
            : 'Answer all ' + WIREFRAME_STEPS.length + ' questions to unlock your recommendations.') + '</p>' +
          '<button type="button" class="tcb-page-btn tcb-page-btn--primary tcb-ef-wireframe-submit__btn" data-wireframe-submit' +
            (wireframeQuizComplete(this.answers) ? '' : ' disabled') + '>See My Recommendations →</button>' +
        '</div>' +
      '</div>';

    this.bindWireframeEvents(q);
    this.updateWireframeSubmitState();
    this.updateLivePreview();
  };

  FinderApp.prototype.bindWireframeEvents = function (q) {
    var self = this;
    if (!q) {
      var stepConfig = WIREFRAME_STEPS[this.wireframeOpenStep];
      q = this.getWireframeQuestion(stepConfig);
    }
    if (!q) return;

    var panel = this.flowMount.querySelector('.tcb-ef-wireframe-step-active');
    if (!panel) return;

    panel.querySelectorAll('.tcb-finder-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-value');
        if (q.multi) {
          var current = Array.isArray(self.answers[q.id]) ? self.answers[q.id].slice() : [];
          var idx = current.indexOf(value);
          if (idx === -1) current.push(value);
          else current.splice(idx, 1);
          self.answers[q.id] = current;
          btn.classList.toggle('is-selected');
          var check = btn.querySelector('.tcb-finder-option__check');
          if (btn.classList.contains('is-selected') && !check) {
            btn.insertAdjacentHTML('beforeend', '<span class="tcb-finder-option__check" aria-hidden="true">✓</span>');
          } else if (!btn.classList.contains('is-selected') && check) {
            check.remove();
          }
        } else {
          self.answers[q.id] = value;
          panel.querySelectorAll('.tcb-finder-option').forEach(function (el) {
            el.classList.toggle('is-selected', el === btn);
            var c = el.querySelector('.tcb-finder-option__check');
            if (el === btn && !c) {
              el.insertAdjacentHTML('beforeend', '<span class="tcb-finder-option__check" aria-hidden="true">✓</span>');
            } else if (el !== btn && c) {
              c.remove();
            }
          });
          var stepAtClick = self.wireframeOpenStep;
          window.setTimeout(function () {
            if (self.wireframeOpenStep !== stepAtClick) return;
            if (stepAtClick < WIREFRAME_STEPS.length - 1) {
              self.advanceWireframeStep();
              return;
            }
            self.updateWireframeSubmitState();
            if (wireframeQuizComplete(self.answers)) {
              var submitWrap = self.flowMount.querySelector('.tcb-ef-wireframe-submit');
              if (submitWrap) submitWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          }, 380);
        }
        var nextBtn = self.flowMount.querySelector('[data-wireframe-next]');
        if (nextBtn) nextBtn.disabled = !hasAnswer(q, self.answers);
        self.updateWireframeSubmitState();
        self.persist();
        self.updateLivePreview();
      });
    });

    var backBtn = this.flowMount.querySelector('[data-wireframe-back]');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        self.goBackWireframeStep();
      });
    }

    var nextBtn = this.flowMount.querySelector('[data-wireframe-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!hasAnswer(q, self.answers)) return;
        self.advanceWireframeStep();
      });
    }

    var budgetSelect = this.flowMount.querySelector('[data-wireframe-budget]');
    if (budgetSelect) {
      budgetSelect.addEventListener('change', function () {
        self.answers.budget = budgetSelect.value || undefined;
        if (!self.answers.budget) delete self.answers.budget;
        self.persist();
        self.updateLivePreview();
      });
    }

    var brandSelect = this.flowMount.querySelector('[data-wireframe-brand]');
    if (brandSelect) {
      brandSelect.addEventListener('change', function () {
        self.answers.preferred_brand = brandSelect.value || undefined;
        if (!self.answers.preferred_brand) delete self.answers.preferred_brand;
        self.persist();
      });
    }

    var submitBtn = this.flowMount.querySelector('[data-wireframe-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        self.submitWireframeResults();
      });
    }
  };

  FinderApp.prototype.render = function () {
    if (this.results) {
      this.setShellVisible(false);
      this.renderResults();
      return;
    }
    if (this.layout === 'wireframe') {
      this.setShellVisible(true);
      if (this.step >= QUESTIONS.length) {
        this.renderEmailStep();
        return;
      }
      this.renderWireframeForm();
      return;
    }
    this.setShellVisible(true);
    if (this.step >= QUESTIONS.length) {
      this.renderEmailStep();
      return;
    }
    this.renderQuestion();
  };

  FinderApp.prototype.renderQuestion = function () {
    var q = QUESTIONS[this.step];
    var stepNum = this.step + 1;
    var optionsHtml = q.options.map(function (opt) {
      return renderOptionButton(q, opt, this.answers);
    }, this).join('');

    this.flowMount.hidden = false;
    if (this.resultsMount) this.resultsMount.hidden = true;

    this.flowMount.innerHTML =
      '<div class="tcb-finder-card" id="tcb-finder-flow">' +
        '<div class="tcb-finder-card__head">' +
          '<span class="tcb-finder-card__step">Step ' + stepNum + ' of ' + TOTAL_STEPS + '</span>' +
          '<div class="tcb-finder-progress" aria-hidden="true">' + renderProgress(this.step) + '</div>' +
        '</div>' +
        '<h2 class="tcb-finder-card__title">' + esc(q.title) + '</h2>' +
        (q.selectionHint ? '<p class="tcb-finder-card__hint">' + esc(q.selectionHint) + '</p>' : '') +
        '<div class="tcb-finder-options tcb-finder-options--' + esc(q.type) + '" role="group" aria-label="' + esc(q.title) + '">' + optionsHtml + '</div>' +
        renderNote(q.note) +
        '<div class="tcb-finder-card__nav">' +
          (this.step > 0 ? '<button type="button" class="tcb-finder-back" data-action="back">← Back</button>' : '<span class="tcb-finder-back-spacer"></span>') +
          '<button type="button" class="tcb-page-btn tcb-page-btn--primary tcb-finder-next" data-action="next"' + (hasAnswer(q, this.answers) ? '' : ' disabled') + '>Next Question →</button>' +
        '</div>' +
      '</div>';

    this.bindQuestionEvents(q);
  };

  FinderApp.prototype.bindQuestionEvents = function (q) {
    var self = this;

    this.flowMount.querySelectorAll('.tcb-finder-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-value');
        if (q.multi) {
          var current = Array.isArray(self.answers[q.id]) ? self.answers[q.id].slice() : [];
          var idx = current.indexOf(value);
          if (idx === -1) current.push(value);
          else current.splice(idx, 1);
          self.answers[q.id] = current;
          btn.classList.toggle('is-selected');
          var check = btn.querySelector('.tcb-finder-option__check');
          if (btn.classList.contains('is-selected') && !check) {
            btn.insertAdjacentHTML('beforeend', '<span class="tcb-finder-option__check" aria-hidden="true">✓</span>');
          } else if (!btn.classList.contains('is-selected') && check) {
            check.remove();
          }
        } else {
          self.answers[q.id] = value;
          self.flowMount.querySelectorAll('.tcb-finder-option').forEach(function (el) {
            el.classList.toggle('is-selected', el === btn);
            var c = el.querySelector('.tcb-finder-option__check');
            if (el === btn && !c) {
              el.insertAdjacentHTML('beforeend', '<span class="tcb-finder-option__check" aria-hidden="true">✓</span>');
            } else if (el !== btn && c) c.remove();
          });
        }
        var nextBtn = self.flowMount.querySelector('[data-action="next"]');
        if (nextBtn) nextBtn.disabled = !hasAnswer(q, self.answers);
        self.persist();
      });
    });

    var nextBtn = this.flowMount.querySelector('[data-action="next"]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!hasAnswer(q, self.answers)) return;
        self.step += 1;
        self.render();
      });
    }

    var backBtn = this.flowMount.querySelector('[data-action="back"]');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        self.step -= 1;
        self.render();
      });
    }
  };

  FinderApp.prototype.renderEmailStep = function () {
    this.flowMount.hidden = false;
    if (this.resultsMount) this.resultsMount.hidden = true;

    this.flowMount.innerHTML =
      '<div class="tcb-finder-card tcb-finder-card--email" id="tcb-finder-flow">' +
        '<div class="tcb-finder-card__head">' +
          '<span class="tcb-finder-card__step">Step ' + TOTAL_STEPS + ' of ' + TOTAL_STEPS + '</span>' +
          '<div class="tcb-finder-progress" aria-hidden="true">' + renderProgress(TOTAL_STEPS - 1) + '</div>' +
        '</div>' +
        '<h2 class="tcb-finder-card__title">Almost there — where should we send your recommendation?</h2>' +
        '<p class="tcb-finder-card__lead">Enter your email to unlock personalized equipment categories and package matches.</p>' +
        '<form class="tcb-finder-email-form" data-tcb-finder-email data-tcb-klaviyo="off" novalidate>' +
          '<label class="tcb-finder-field"><span>Email address *</span><input type="email" name="email" required autocomplete="email" placeholder="you@company.com"></label>' +
          '<label class="tcb-finder-field"><span>First name <em>(optional)</em></span><input type="text" name="first_name" autocomplete="given-name" placeholder="First name"></label>' +
          '<label class="tcb-finder-field"><span>Phone <em>(optional)</em></span><input type="tel" name="phone" autocomplete="tel" placeholder="(321) 555-0100"></label>' +
          '<label class="tcb-finder-field"><span>Business name <em>(optional)</em></span><input type="text" name="business_name" autocomplete="organization" placeholder="Your company"></label>' +
          '<div class="tcb-finder-checks">' +
            '<label><input type="checkbox" name="email_recommendations" checked> Email me my recommendations</label>' +
            '<label><input type="checkbox" name="expert_followup" checked> Our experts can review and follow up</label>' +
            '<label><input type="checkbox" name="no_spam" checked disabled> No spam. Only equipment help and recommendations.</label>' +
          '</div>' +
          '<p class="tcb-finder-email-error" data-tcb-finder-email-error hidden></p>' +
          '<div class="tcb-finder-card__nav tcb-finder-card__nav--email">' +
            '<button type="button" class="tcb-finder-back" data-action="back">← Back</button>' +
            '<button type="submit" class="tcb-page-btn tcb-page-btn--primary tcb-finder-submit">Show My Recommendations →</button>' +
          '</div>' +
          '<p class="tcb-finder-secure">🔒 Your information is secure and never sold.</p>' +
        '</form>' +
      '</div>';

    var self = this;
    this.flowMount.querySelector('[data-action="back"]').addEventListener('click', function () {
      if (self.layout === 'wireframe') {
        self.step = 0;
      } else {
        self.step = QUESTIONS.length - 1;
      }
      self.render();
    });
    this.flowMount.querySelector('[data-tcb-finder-email]').addEventListener('submit', function (e) {
      e.preventDefault();
      self.handleEmailSubmit(e.target);
    });
  };

  FinderApp.prototype.handleEmailSubmit = function (form) {
    var email = form.email.value.trim();
    var errorEl = this.flowMount.querySelector('[data-tcb-finder-email-error]');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.hidden = false;
      return;
    }
    errorEl.hidden = true;
    this.results = getRecommendations(this.answers);
    this.persist();
    this.syncLeadForm(form, email);
    this.captureKlaviyoLead(form, email);
    if (window.tcbAnalytics) {
      window.tcbAnalytics.finderEmailCaptured(email);
      window.tcbAnalytics.finderCompleted(this.answers);
    }
    this.submitLeadAsync();
    this.flowMount.hidden = true;
    this.render();
  };

  FinderApp.prototype.captureKlaviyoLead = function (form, email) {
    if (!window.TcbKlaviyo || !window.TcbKlaviyo.enabled || !window.TcbKlaviyo.enabled()) return;
    var rec = this.results || { products: [], packages: [] };
    var recsCheckbox = form.querySelector('input[name="email_recommendations"]');
    var expertFollowup = form.querySelector('input[name="expert_followup"]');
    window.TcbKlaviyo.capture({
      email: email,
      firstName: form.first_name.value.trim(),
      phone: form.phone.value.trim(),
      organization: form.business_name.value.trim(),
      source: 'Equipment Finder Questionnaire',
      listType: 'lead',
      subscribeMarketing: !recsCheckbox || recsCheckbox.checked,
      properties: {
        equipment_finder_answers: JSON.stringify(this.answers),
        facility: labelForQuestion('facility', this.answers.facility),
        equipment_type: labelForQuestion('equipment', this.answers.equipment),
        cleaning_task: labelForQuestion('task', this.answers.task),
        budget: labelForQuestion('budget', this.answers.budget),
        recommended_products: rec.products.map(function (p) { return p.name; }).join(', '),
        recommended_packages: rec.packages.map(function (p) { return p.name; }).join(', '),
        expert_followup: !!(expertFollowup && expertFollowup.checked)
      }
    });
  };

  FinderApp.prototype.syncLeadForm = function (form, email) {
    if (!this.leadForm) return;
    var rec = this.results;
    var summary = this.buildAnswerSummary();
    setVal(this.leadForm, 'contact[email]', email);
    setVal(this.leadForm, 'contact[name]', form.first_name.value.trim());
    setVal(this.leadForm, 'contact[phone]', form.phone.value.trim());
    setVal(this.leadForm, 'contact[Business Name]', form.business_name.value.trim());
    setVal(this.leadForm, 'contact[Equipment Finder Answers]', JSON.stringify(this.answers));
    setVal(this.leadForm, 'contact[Recommended Products]', rec.products.map(function (p) { return p.name + ' — ' + p.url; }).join('\n'));
    setVal(this.leadForm, 'contact[Recommended Packages]', rec.packages.map(function (p) { return p.name + ' — ' + p.url; }).join('\n'));
    setVal(this.leadForm, 'contact[Budget]', labelForQuestion('budget', this.answers.budget));
    setVal(this.leadForm, 'contact[Facility]', labelForQuestion('facility', this.answers.facility));
    setVal(this.leadForm, 'contact[Equipment Type]', labelForQuestion('equipment', this.answers.equipment));
    setVal(this.leadForm, 'contact[Cleaning Task]', labelForQuestion('task', this.answers.task));
    setVal(this.leadForm, 'contact[Source Page]', 'Equipment Finder');
    setVal(this.leadForm, 'contact[body]', summary + '\n\nRecommended products:\n' + rec.products.map(function (p) { return '- ' + p.name; }).join('\n') + '\n\nRecommended packages:\n' + rec.packages.map(function (p) { return '- ' + p.name; }).join('\n'));
  };

  FinderApp.prototype.submitLeadAsync = function () {
    /* Shopify contact POST requires hCaptcha — use Klaviyo capture + contact page prefill instead. */
  };

  FinderApp.prototype.emailExpertToContact = function () {
    var email = '';
    var firstName = '';
    var phone = '';
    var businessName = '';
    var emailForm = this.root.querySelector('[data-tcb-finder-email]');

    if (emailForm) {
      email = (emailForm.email && emailForm.email.value.trim()) || email;
      firstName = (emailForm.first_name && emailForm.first_name.value.trim()) || firstName;
      phone = (emailForm.phone && emailForm.phone.value.trim()) || phone;
      businessName = (emailForm.business_name && emailForm.business_name.value.trim()) || businessName;
    }

    if (this.leadForm) {
      for (var i = 0; i < this.leadForm.elements.length; i++) {
        var field = this.leadForm.elements[i];
        if (field.name === 'contact[email]' && field.value) email = field.value.trim();
        if (field.name === 'contact[name]' && field.value) firstName = field.value.trim();
        if (field.name === 'contact[phone]' && field.value) phone = field.value.trim();
        if (field.name === 'contact[Business Name]' && field.value) businessName = field.value.trim();
      }
    }

    if (!this.results) {
      this.results = getRecommendations(this.answers);
    }

    if (emailForm && email) {
      this.syncLeadForm(emailForm, email);
    } else if (this.leadForm && email) {
      setVal(this.leadForm, 'contact[email]', email);
      setVal(this.leadForm, 'contact[name]', firstName);
      setVal(this.leadForm, 'contact[phone]', phone);
      setVal(this.leadForm, 'contact[Business Name]', businessName);
      setVal(this.leadForm, 'contact[Equipment Finder Answers]', JSON.stringify(this.answers));
      setVal(this.leadForm, 'contact[body]', this.buildAnswerSummary());
    }

    var rec = this.results || { products: [], packages: [] };
    var description = this.buildAnswerSummary();
    if (rec.products.length) {
      description += '\n\nRecommended products:\n' + rec.products.map(function (p) { return '- ' + p.name; }).join('\n');
    }
    if (rec.packages.length) {
      description += '\n\nRecommended packages:\n' + rec.packages.map(function (p) { return '- ' + p.name; }).join('\n');
    }

    try {
      sessionStorage.setItem('tcb-contact-prefill', JSON.stringify({
        topic: 'equipment-finder',
        email: email,
        first_name: firstName,
        phone: phone,
        company: businessName,
        description: description
      }));
    } catch (e) { /* ignore storage failures */ }

    window.location.assign(this.quoteUrl || '/pages/contact?topic=equipment-finder#tcb-finder-lead-form');
  };

  FinderApp.prototype.buildAnswerSummary = function () {
    return QUESTIONS.map(function (q) {
      return q.title + ': ' + labelForQuestion(q.id, this.answers[q.id]);
    }, this).join('\n');
  };

  FinderApp.prototype.renderAnswerChips = function () {
    var mount = this.resultsMount.querySelector('[data-answer-chips]');
    if (!mount) return;
    var chips = SUMMARY_FIELDS.map(function (field) {
      var value = labelForQuestion(field.id, this.answers[field.id]);
      if (!value) return '';
      return '<span class="tcb-answer-chip"><span class="tcb-answer-chip__label">' + esc(field.label) + '</span><span class="tcb-answer-chip__value">' + esc(value) + '</span></span>';
    }, this).filter(Boolean).join('');
    mount.innerHTML = chips;
  };

  FinderApp.prototype.renderAddons = function () {
    var mount = this.resultsMount.querySelector('[data-addons]');
    if (!mount) return;
    var list = ADD_ONS.slice(0, 10);
    mount.innerHTML = list.map(function (item) {
      return '<a class="tcb-addon-pill" href="' + esc(item.url) + '">' + esc(item.name) + '</a>';
    }).join('');
  };

  function renderPrimaryGrid(items, type, answers) {
    if (!items.length) {
      return '<p class="tcb-finder-empty">No ' + (type === 'product' ? 'equipment categories' : 'packages') + ' matched.</p>';
    }
    return items.map(function (item, index) {
      return renderResultCard(
        item,
        type,
        buildItemReasonText(item, answers),
        type === 'product' ? 'View Category' : 'View Package',
        index === 0
      );
    }).join('');
  }

  FinderApp.prototype.renderResults = function () {
    var rec = this.results;
    if (!this.resultsMount || !rec) return;

    this.resultsMount.hidden = false;
    this.setShellVisible(false);
    this.setStaticFooterVisible(false);

    var products = dedupeByUrl(rec.products || []);
    var packages = dedupeByUrl(rec.packages || []);
    var primaryProducts = products.slice(0, PRIMARY_GRID_SIZE);
    var primaryPackageItems = packages.slice(0, PRIMARY_GRID_SIZE);
    var secondaryProducts = products.slice(PRIMARY_GRID_SIZE, PRIMARY_GRID_SIZE + SECONDARY_GRID_SIZE);
    var secondaryPackages = packages.slice(PRIMARY_GRID_SIZE, PRIMARY_GRID_SIZE + SECONDARY_GRID_SIZE);
    var packageFirst = wantsPackageFirst(this.answers);

    var summaryEl = this.resultsMount.querySelector('[data-result-summary]');
    if (summaryEl) {
      summaryEl.textContent = packageFirst
        ? 'Based on your answers, these package options and equipment categories are the best fit for your facility.'
        : 'Based on your answers, these equipment categories and package options are the best fit for your facility.';
    }

    var usedAlert = this.resultsMount.querySelector('[data-used-alert]');
    if (usedAlert) usedAlert.hidden = !rec.usedRefurbNote;

    rootQuery(this.resultsMount, '[data-result-quote]').forEach(function (link) {
      link.setAttribute('href', this.quoteUrl);
    }, this);

    var primaryResults = this.resultsMount.querySelector('[data-primary-results]');
    var equipmentBlock = this.resultsMount.querySelector('[data-primary-equipment-block]');
    var packagesBlock = this.resultsMount.querySelector('[data-primary-packages-block]');
    var primaryEquipment = this.resultsMount.querySelector('[data-primary-equipment]');
    var primaryPackagesMount = this.resultsMount.querySelector('[data-primary-packages]');
    var equipmentHeading = this.resultsMount.querySelector('[data-primary-equipment-heading]');
    var packagesHeading = this.resultsMount.querySelector('[data-primary-packages-heading]');
    var moreProducts = this.resultsMount.querySelector('[data-more-products]');
    var morePackages = this.resultsMount.querySelector('[data-more-packages]');
    var secondaryEquipmentSection = this.resultsMount.querySelector('[data-secondary-equipment-section]');
    var secondaryPackagesSection = this.resultsMount.querySelector('[data-secondary-packages-section]');

    if (primaryEquipment) {
      primaryEquipment.innerHTML = renderPrimaryGrid(primaryProducts, 'product', this.answers);
    }
    if (primaryPackagesMount) {
      primaryPackagesMount.innerHTML = renderPrimaryGrid(primaryPackageItems, 'package', this.answers);
    }
    if (equipmentHeading) {
      equipmentHeading.textContent = packageFirst
        ? 'Recommended Equipment Categories'
        : 'Recommended Equipment Categories for Your Answers';
    }
    if (packagesHeading) {
      packagesHeading.textContent = packageFirst
        ? 'Recommended Packages for Your Facility'
        : 'Recommended Packages for Your Answers';
    }
    if (primaryResults && equipmentBlock && packagesBlock) {
      if (packageFirst) {
        primaryResults.insertBefore(packagesBlock, equipmentBlock);
      } else {
        primaryResults.insertBefore(equipmentBlock, packagesBlock);
      }
    }

    if (moreProducts) {
      var answers = this.answers;
      moreProducts.innerHTML = secondaryProducts.length
        ? secondaryProducts.map(function (item) {
          return renderResultCard(item, 'product', buildItemReasonText(item, answers), 'View Category', false);
        }).join('')
        : '';
    }
    if (morePackages) {
      var packageAnswers = this.answers;
      morePackages.innerHTML = secondaryPackages.length
        ? secondaryPackages.map(function (item) {
          return renderResultCard(item, 'package', buildItemReasonText(item, packageAnswers), 'View Package', false);
        }).join('')
        : '';
    }
    if (secondaryEquipmentSection) {
      secondaryEquipmentSection.hidden = !secondaryProducts.length;
    }
    if (secondaryPackagesSection) {
      secondaryPackagesSection.hidden = !secondaryPackages.length;
    }

    this.renderAnswerChips();
    this.renderAddons();

    var gallerySection = this.resultsMount.querySelector('[data-results-gallery]');
    var galleryGrid = this.resultsMount.querySelector('[data-results-gallery-grid]');
    if (gallerySection && galleryGrid) {
      var showGallery = this.answers.intent === 'show_photos';
      gallerySection.hidden = !showGallery;
      if (showGallery) {
        galleryGrid.innerHTML = GALLERY.map(renderGalleryCard).join('');
      }
    }

    var browseGrid = this.resultsMount.querySelector('[data-results-browse-grid]');
    if (browseGrid) {
      browseGrid.innerHTML = BROWSE_PACKAGES.map(renderBrowseCard).join('');
    }

    var self = this;
    var resetBtn = this.resultsMount.querySelector('[data-reset]');
    if (resetBtn && !resetBtn.dataset.bound) {
      resetBtn.dataset.bound = '1';
      resetBtn.addEventListener('click', function () { self.reset(); });
    }

    var hero = this.resultsMount.querySelector('.tcb-results-hero');
    if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  FinderApp.prototype.reset = function () {
    this.step = 0;
    this.wireframeOpenStep = 0;
    this.answers = { task: [] };
    this.results = null;
    sessionStorage.removeItem(STORAGE_KEY);
    if (this.resultsMount) {
      this.resultsMount.hidden = true;
      var slots = ['[data-primary-equipment]', '[data-primary-packages]', '[data-more-products]', '[data-more-packages]', '[data-answer-chips]', '[data-addons]', '[data-results-gallery-grid]', '[data-results-browse-grid]'];
      slots.forEach(function (sel) {
        var el = this.resultsMount.querySelector(sel);
        if (el) el.innerHTML = '';
      }, this);
    }
    this.setShellVisible(true);
    this.setStaticFooterVisible(true);
    this.render();
    var target = this.root.querySelector('#tcb-finder-flow');
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  function setVal(form, name, value) {
    for (var i = 0; i < form.elements.length; i++) {
      if (form.elements[i].name === name) {
        form.elements[i].value = value || '';
        return;
      }
    }
  }

  function rootQuery(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function init() {
    document.querySelectorAll('[data-tcb-equipment-finder]').forEach(function (root) {
      if (root.__finder) return;
      try {
        root.__finder = new FinderApp(root);
      } catch (err) {
        console.error('TCB Equipment Finder failed to initialize', err);
      }
    });
  }

  window.TCBEquipmentFinderInit = init;

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target && e.target.querySelector ? e.target : document;
    var root = target.querySelector('[data-tcb-equipment-finder]');
    if (root && !root.__finder) new FinderApp(root);
  });
  document.addEventListener('tcb:finder-quiz-recovered', init);
})();
